import React from "react"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { AlternativeLoginForSaml } from "./AlternativeLogin"
import { SubmitButton } from "../../components/SubmitButton"
import { useLoginService } from "../../providers/LoginService/context"

export const LoginWithSamlScreenContent = () => {
  const { i18n } = useTranslations()
  const { loginWithSaml } = useLoginService()

  return <>
    <SubmitButton label={`${i18n("Account.Login:LoginWith")} SAML 2.0`} onClick={loginWithSaml}/>
    <AlternativeLoginForSaml/>
  </>
}
